import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import "../spf.scss";
import "./spf-kit.scss";
import { Breadcrumb, Button, Form, Input, Steps, Switch, message } from "antd";
import { Content } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import { useDealer } from "../../../../tools/api";

import { convertPersian, validateInput } from "../../../../tools/tools";
import SPFSearchMsisdnBundle from "./spf-searchMsisdnBundle";
import SPFBundleList from "./spf-bundle";
import React, { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearFormData } from "../../../../reducer/serviceReducer";
import { clearGlobalFormData } from "../../../../reducer/serviceReducerGlobala";
import SPFShopLayout from "../spf-shop-layout";
import { clearTokenOTP, switchPlanID } from "../../../../tools/services";

const SPFKit = () => {
  //#region Hooks Additional
  const [t] = useTranslation("global");
  const { queryBundleSalesSimByKit, validateKitNo } = useDealer();
  const formData = useSelector((state) => state);
  const dispatch = useDispatch();
  //#endregion Hooks Additional
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();

  //#region statements

  //Progress On ValidKKit
  const [isProgress, setIsProgress] = useState(false);
  //Check exist Bundle
  const [isValidBundle, setIsValidBundle] = useState(false);

  //show Special Search MSISDN
  const [isShowBoxSearch, setIsShowBoxSearch] = useState(false);

  //bundle list
  const [bundles, setBundle] = useState([]);

  //msisdn assign the bundle
  const [msisdnBundle, setMsisdnBundle] = useState([]);

  //kit for Bundle
  const [kitBundle, setKitBundle] = useState(location?.state?.kit || "");

  //iccid sate
  const [iccid, setIccid] = useState("");

  //#endregion statements
  // ورود به این صفحه یعنی شروع یه درخواست تازه؛ هرچی از درخواست قبلی مونده (session و بک‌آپ لوکال‌استوریج) پاک بشه
  useEffect(() => {
    dispatch(clearFormData(["spForeign"]));
    dispatch(clearGlobalFormData(["spForeign"]));
    clearTokenOTP();
  }, [dispatch]);

  const handleSubmit = async (param) => {
    dispatch(clearFormData(["spForeign"]));
    setIsProgress(true);
    setKitBundle(param.kit);
    let payload = {
      kitno: param.kit,
    };
    let resValid = await validateKitNo(payload);
    if (resValid) {
      setIccid(resValid.iccid);
      payload = {
        kitno: param.kit,
        planid: switchPlanID().simPurchaseForeign,
      };
      let response = await queryBundleSalesSimByKit(payload);
      //check has Item
      if (response?.bundle.length > 0 || response?.spBundle?.length > 0) {
        setIsValidBundle(true);
        //check has Item spBundle
        let resultCatID = [];
        response.spBundle.forEach((element) => {
          let matchItem = resultCatID.filter((item) => item.bundleSalesSimId === element.bundleSalesSimId);
          if (matchItem.length === 0) {
            resultCatID.push(element);
          }
        });
        resultCatID = resultCatID.map((bundle) => {
          return {
            ...bundle,
            attribute: response.spBundle.filter((item) => bundle.bundleSalesSimId === item.bundleSalesSimId),
          };
        });
        resultCatID = resultCatID.sort((a, b) => {
          if (a.attributeOrderId > b.attributeOrderId) return 1;
          else return -1;
        });

        resultCatID = resultCatID.sort((a, b) => {
          if (a.bundleOrder > b.bundleOrder) return 1;
          else return -1;
        });

        setBundle(resultCatID);
        let msisdnList =
          response?.bundle.filter((item) => item.inT_MSISDN > 0).length > 0 ? response?.bundle.filter((item) => item.inT_MSISDN > 0) : [];
        setMsisdnBundle(msisdnList);
      } else {
        messageApi.open({
          type: "error",
          content: "رکوردی برای نمایش وجود ندارد",
        });
      }
    } else {
      setBundle([]);
      setMsisdnBundle([]);
      setIsValidBundle(false);
    }
    setIsProgress(false);
    setIsShowBoxSearch(false);
  };

  return (
    <>
      <SPFShopLayout>
        {contextHolder}
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.foreigners.title") }]}
          />
          <div className="title-page">
            <h3>{t("simcardpurchase.foreigners.title")}</h3>
          </div>
        </div>

        <div className="g-layout-content">
          <Content className="g-layout-main spf-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="g-format-steps">
                  <div className="holder-step">
                    <Steps
                      size="small"
                      className="step-wizard"
                      current={0}
                      items={[
                        {
                          title: "بسته آغازین",
                        },
                        {
                          title: "احراز هویت",
                        },
                        {
                          title: "اطلاعات هویتی",
                        },
                        {
                          title: "پیش فاکتور",
                        },
                        {
                          title: "سند",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="kit-container">
                  <div className="hold-kit-box">
                    <h3>{t("simcardpurchase.kit.title_form")}</h3>
                    <Form
                      initialValues={{
                        kit: kitBundle,
                      }}
                      name="frm_valid_kit"
                      layout="inline"
                      onFinish={handleSubmit}
                    >
                      <Form.Item
                        className="input-normal"
                        style={{ padding: "0" }}
                        name="kit"
                        rules={[validateInput({ t: t, validate: true, type: "number" })]}
                        extra={
                          <>
                            {msisdnBundle.length > 0 && (
                              <div className="holder-result">
                                <p>
                                  شماره کیت متعلق به شماره موبایل
                                  {msisdnBundle.map((item, key) =>
                                    key === 0 ? (
                                      <React.Fragment key={key}>
                                        <span dir="ltr"> {item.inT_MSISDN} </span>
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment key={key}>
                                        <span key={key} dir="ltr">
                                          {" "}
                                          {item.inT_MSISDN}{" "}
                                        </span>
                                        {" ,"}
                                      </React.Fragment>
                                    ),
                                  )}
                                  می‌باشد
                                </p>
                              </div>
                            )}
                          </>
                        }
                      >
                        <div>
                          <label>{t("simcardpurchase.kit.label_input")}</label>
                          <Input
                            dir="ltr"
                            placeholder={t("simcardpurchase.kit.placehoder_input_kit")}
                            inputMode="numeric"
                            maxLength={9}
                            defaultValue={kitBundle}
                            onChange={(e) => {
                              e.target.value = convertPersian(e.target.value);
                            }}
                            showCount
                          />
                        </div>
                      </Form.Item>
                      <Form.Item>
                        <label></label>
                        <br />
                        <Button className="btn-normal btn-green" type="default" disabled={isProgress} htmlType="submit">
                          {isProgress ? t("form.inProgress") : t("simcardpurchase.kit.buttonKitValid")}
                        </Button>
                      </Form.Item>
                    </Form>

                    {isValidBundle && (
                      <>
                        <div className="hold-opration">
                          {msisdnBundle.length === 0 && (
                            <div className="holder-checked">
                              <div className="row-checked">
                                <div className="label-hold">
                                  <label htmlFor="">شماره خاص می خواهم</label>
                                </div>
                                <div className="checked-hold">
                                  <Switch
                                    size="small"
                                    className="switcherOpration"
                                    defaultChecked={isShowBoxSearch}
                                    checked={isShowBoxSearch}
                                    onChange={() => {
                                      setIsShowBoxSearch((prev) => !prev);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {isShowBoxSearch && <SPFSearchMsisdnBundle iccid={iccid} kitbundle={kitBundle} />}
                          {!isShowBoxSearch && (
                            <div className="g-list-bundle">
                              <SPFBundleList
                                iccid={iccid}
                                bundles={bundles}
                                kitbundle={kitBundle}
                                msisdn={msisdnBundle.map((item) => item.inT_MSISDN)}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </SPFShopLayout>
    </>
  );
};

export default SPFKit;
